import type {
  TimeInputValue,
  DateInputValue,
} from '@doxyme/ui/components/foundations';
import dayjs from 'dayjs';

/**
 * Format date to be used as part of the invitation content in both text and email invited.
 */
export const getFormattedDate = (
  date: DateInputValue,
  locale: string,
): string => {
  return date !== null
    ? `${dayjs(date).locale(locale).format('ddd, MMM D')}`
    : '';
};

/**
 * Format time to be used as part of the invitation content in both text and email invited.
 */
export const getFormattedTime = (time: TimeInputValue): string => {
  if (time !== null) {
    const mins = dayjs(time).minute();
    if (mins === 0) {
      return dayjs(time).format('ha');
    }

    return dayjs(time).format('h:mma');
  }
  return '';
};
